webpackJsonp([25,35],{

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(156),
	  /* template */
	  __webpack_require__(247),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 155:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'content',
	  components: {},
	  props: {},
	  methods: {
	    switchState: function switchState() {
	      this.open = !this.open;
	    }
	  },
	  computed: {
	    state: function state() {
	      return this.open ? 'content-open' : 'content-close';
	    }
	  },
	  data: function data() {
	    return {
	      open: false
	    };
	  }
	};

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _content = __webpack_require__(214);
	
	var _content2 = _interopRequireDefault(_content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'contentdemo',
	  components: {
	    boContent: _content2.default
	  },
	  created: function created() {},
	
	  methods: {},
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(155),
	  /* template */
	  __webpack_require__(269),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('bo-content', [_c('p', [_vm._v("巴旦木其实就是过去我们比较熟悉的大杏仁（美国加州大杏仁），只是因为其实它是扁桃仁，不是杏的仁，因此按照食品安全法，为了不让大家引起歧义，必须改为巴旦木或者扁桃仁。\n\n从营养角度来说，它大概含有一半脂肪，还有接近20%的蛋白质，这些和一般的坚果没有太多区别，主要的差异在于它的膳食纤维、钙含量比普通坚果多很多。\n\n")])])
	},staticRenderFns: []}

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content",
	    class: _vm.state,
	    on: {
	      "click": _vm.switchState
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/25.1d0823d205ab636936e0.js